module.exports = __webpack_public_path__ + "assets/img/img304.372535cf.png";